import { MinzeElement } from 'minze'

export interface LvcHidePasswordIcon {}

export class LvcHidePasswordIcon extends MinzeElement {
  html = () => `
    <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30 15.8226C25.9562 12.1237 20.9321 7.43859 13.9475 8.05507C8.35979 8.54825 3.65429 13.4389 2 15.8226C3.5726 18.6172 9.37716 24.1696 14.262 24.1696C22.8092 24.1696 25.221 21.2065 30 17.1995M16.2858 13.0645C17.076 13.1842 17.7126 13.5796 18.1227 14.1117C18.5328 14.6438 18.8059 15.2654 18.9188 15.9236C19.0144 16.57 18.8846 17.2291 18.5505 17.7938C18.2164 18.3585 17.6977 18.7955 17.0788 19.0337C16.4494 19.2393 15.7751 19.2739 15.1273 19.1338C14.4795 18.9938 13.8823 18.6843 13.3988 18.2381C12.8814 17.7602 12.5381 17.1286 12.4218 16.4403C12.3055 15.7519 12.4226 15.0451 12.7551 14.4286C13.0876 13.8121 13.617 13.3201 14.262 13.0282C14.799 12.7852 15.4906 12.6873 16.0946 12.762" stroke="#1E007D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
 `

  css = () => `
    
  `
}
